(function(){
    'use strict';

    angular
        .module('ead.uc', ['ngMask']);
})();